import { Link } from "react-router-dom";
import { EmptyState } from "../../components/app/EmptyState";
import { Badge } from "../../components/ui/badge";
import { Button } from "../../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { formatDateRange, formatShortDate } from "../../lib/baseline/format";
import { useCurrentCompany, useSession } from "../../services/SessionContext";

export function RepositoryPage() {
  const { repo } = useSession();
  const company = useCurrentCompany();
  if (!company) return null;
  const uploads = repo.getCompanyUploads(company.companyId);

  return (
    <div className="space-y-6 pb-20 md:pb-0">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-navy-950">Company repository</h1>
          <p className="mt-1 text-sm text-slate-600">All saved Baseline event files for {company.name}.</p>
        </div>
        <Button asChild>
          <Link to="/app/uploads/new">Upload event file</Link>
        </Button>
      </div>
      {uploads.length === 0 ? (
        <EmptyState title="Upload your first Baseline event file." />
      ) : (
        <div className="grid gap-4">
          {uploads.map((upload) => (
            <Card key={upload.uploadId}>
              <CardContent className="flex flex-col gap-4 p-5 sm:flex-row sm:items-center sm:justify-between">
                <div>
                  <Link className="text-lg font-semibold text-navy-900 hover:underline" to={`/app/uploads/${upload.uploadId}`}>
                    {upload.projectName || upload.controllerName || upload.originalFileName}
                  </Link>
                  <p className="mt-1 text-sm text-slate-600">{upload.controllerName || upload.originalFileName}</p>
                  <p className="mt-2 text-sm text-slate-500">
                    {formatDateRange(upload.dateRangeStart, upload.dateRangeEnd)} · Uploaded {formatShortDate(upload.createdAt)}
                  </p>
                </div>
                <div className="flex flex-wrap gap-2">
                  <Badge className="bg-sky-50 text-sky-800 ring-sky-200">{upload.rowCount.toLocaleString()} events</Badge>
                  <Badge className="bg-amber-50 text-amber-800 ring-amber-200">{upload.warningCount} warnings</Badge>
                  <Badge className="bg-red-50 text-red-800 ring-red-200">{upload.criticalIssueCount} critical</Badge>
                  <Badge className="bg-field-100 text-field-600 ring-field-600/20">{upload.status}</Badge>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
